var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[(!_vm.partnerContent.name)?_c('consulting-heumtax'):(_vm.partnerContent.name === 'fastfive')?_c('consulting-fastfive'):_c('consulting-partner')],1)}
var staticRenderFns = []

export { render, staticRenderFns }